import type { RequestFn } from 'api/useApiRequest';

export const requestCustomSource = (
  request: RequestFn,
  { signal, ...data }: { signal?: AbortSignal; sourceName: string; url: string }
) =>
  request({
    method: 'post',
    pathname: '/api/feed/request-custom-source',
    data,
    signal,
  });
